import React, { useEffect } from "react";
import * as v from "valibot";
import { valibotResolver } from "@hookform/resolvers/valibot";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { PageHeading } from "../../../components/common/pageHeading/PageHeading";

import { useForm } from "react-hook-form";
import { Input } from "../../../components/common/input/Input";

import { CustomToast } from "../../../components/common/customToast/CustomToast";
import { Loader } from "../../../components/common/loader/Loader";
import {
  useGetCustomerQuery,
  useUpdateCustomerMutation,
} from "../../../features/api/customers/customersApi";
const phoneRegex = /^\+([3-9][0-9]{1,2})[0-9]{6,12}$/;
const schema = v.object({
  email: v.optional(v.email()), // Optional but must be valid email if present
  phone: v.optional(v.regex(phoneRegex, "Invalid phone number")),
  address: v.pipe(
    v.string("Address is required"),
    v.minLength(3, "Address is required")
  ),
  deliveryAddress: v.pipe(
    v.string("Delivery address is required"),
    v.minLength(3, "Address is required")
  ),
  firstName: v.pipe(
    v.string("First name is required"),
    v.minLength(3, "First name is required")
  ),
  lastName: v.pipe(
    v.string("Last name is required"),
    v.minLength(3, "Last name is required")
  ),
  companyName: v.pipe(
    v.string("Company name is required"),
    v.minLength(3, "Company name is required")
  ),
  registrationNo: v.pipe(
    v.string("Registration no is required"),
    v.minLength(3, "Registration no is required")
  ),
});

export const EditCustomer = () => {
  const [updateCustomer, { isLoading, isSuccess, isError, error }] =
    useUpdateCustomerMutation();
  const navigate = useNavigate();
  const { customerId } = useParams();
  const { data: customerDetail } = useGetCustomerQuery(customerId);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: customerDetail,
    resolver: valibotResolver(schema),
    mode: "onChange",
  });
  useEffect(() => {
    if (customerDetail) {
      reset(customerDetail);
    }
  }, [customerDetail, reset]);

  const onSubmit = async (data) => {
    try {
      data.id = customerId;
      await updateCustomer(data).unwrap();

      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } catch (err) {}
    reset();
  };

  // Decide what to render -
  let content = null;
  if (isLoading) {
    content = (
      <div className="mb-5">
        <PageHeading title="Edit Customer" />
        <Loader />
      </div>
    );
  }
  if (customerDetail) {
    content = (
      <div className="mb-5">
        {isError && <CustomToast err={error} msg={error.data.errorMessage} />}
        {isSuccess && <CustomToast msg={"Customer updated successfully!"} />}
        <PageHeading title="Edit Customer" />
        <Container className="mt-5 shadow-sm">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col lg={6} md={6} xs={12}>
                <Input
                  label={"Company name"}
                  field={"companyName"}
                  register={register}
                  errors={errors}
                />
                <Input
                  label={"Address"}
                  field={"address"}
                  register={register}
                  errors={errors}
                />
                <Input
                  label={"Delivery address"}
                  field={"deliveryAddress"}
                  register={register}
                  errors={errors}
                />
                <Input
                  label={"Phone"}
                  field={"phone"}
                  register={register}
                  errors={errors}
                />
              </Col>
              <Col lg={6} md={6} xs={12}>
                <Input
                  label={"Email"}
                  field={"email"}
                  register={register}
                  errors={errors}
                />

                <Input
                  label={"Registration no"}
                  field={"registrationNo"}
                  register={register}
                  errors={errors}
                />
                <Input
                  label={"Last name"}
                  field={"lastName"}
                  register={register}
                  errors={errors}
                />
                <Input
                  label={"First name"}
                  field={"firstName"}
                  register={register}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row className="py-2 d-flex justify-content-center g-2">
              <Col lg={2}>
                <Button
                  type="button"
                  variant="secondary"
                  className="w-100"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
              </Col>
              <Col lg={2}>
                <Button type="submit" variant="success" className="w-100">
                  Save Changes
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    );
  }

  return content;
};
